import { map } from 'rxjs/operators';
import { filter, Observable, of } from 'rxjs';
import { FailureCode, FailureTypesGQL, Maybe } from '@iss/libs/graphql';
import {
  ChangeDetectorRef,
  inject,
  OnDestroy,
  Pipe,
  PipeTransform,
} from '@angular/core';
import { AsyncPipe } from '@angular/common';

import { CapitalizePipe } from './capitalize.pipe';

@Pipe({ name: 'failureName', pure: false, standalone: true })
export class FailureNamePipe implements PipeTransform, OnDestroy {
  private readonly failureTypes = inject(FailureTypesGQL);
  private readonly asyncPipe = new AsyncPipe(inject(ChangeDetectorRef));
  private readonly capitalize = new CapitalizePipe();
  private code?: Maybe<FailureCode>;
  private name$!: Observable<string | null>;

  public transform(code: Maybe<FailureCode>): string | null {
    if (this.code !== code) {
      this.code = code;
      this.name$ = code ? this.fetch(code) : of(null);
    }

    return this.asyncPipe.transform(this.name$);
  }

  public ngOnDestroy(): void {
    this.asyncPipe.ngOnDestroy();
  }

  protected fetch(code: FailureCode): Observable<string> {
    return this.failureTypes.fetch().pipe(
      map(({ data }) => data),
      filter(Boolean),
      map(({ failureTypes }) => failureTypes.find(x => x.name === code)?.presentedName || this.capitalize.transform(code)),
    );
  }
}
